/* eslint-disable */
// import anime from 'animejs';
import loadMore from './load-more.js'

export default {
  init() {
    // scripts here run on the DOM load event
  },
  finalize() {

    $( ".link-listing-show-more" ).click(function(event) {
      event.preventDefault();

      loadMore.handle($(this), '.link-item');
    });

    // var isLinkListingReset = false;
    //
    // $( ".link-listing-show-more" ).click(function(event) {
    //
    //   event.preventDefault();
    //
    //   const currentID = $(this).closest('.link-listing').attr('id');
    //   let currentLinkList = $(this.parentNode.parentNode.parentNode).find( ".link-listing-wrapper" ); //jquery obj
    //   let allLinksElements =  $( currentLinkList ).find( ".link-item" );
    //   let hiddenElements = $( currentLinkList ).find( ".link-item.hidden" );
    //   let iTheElementCount = $(this.parentNode.parentNode.parentNode).attr('data-element-count');
    //   const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;
    //
    //   var counter = 0;
    //   var iTheDelay = 80;
    //
    //   if (!isLinkListingReset) {
    //
    //     hiddenElements.each(function() {
    //       if (counter < iTheElementCount) {
    //         setTimeout(() => {
    //           $(this).removeClass('hidden -in').addClass('-out');
    //         }, iTheDelay * counter);
    //       }
    //       counter++;
    //     });
    //
    //     setTimeout(() => {
    //       if (!$( currentLinkList ).find( ".link-item.hidden" ).length) {
    //
    //           $(this).children('span').text($(this).attr("data-close-label"));
    //           $(this).children('.icon').addClass('arrow-up');
    //           isLinkListingReset = true;
    //       }
    //     }, 200);
    //
    //   } else {
    //
    //     iTheDelay = 100;
    //     isLinkListingReset = false;
    //     $(this).children('.icon').removeClass('arrow-up');
    //     $(this).children('span').text($(this).attr("data-open-label"));
    //
    //     var animateTo = $('#'+currentID);
    //
    //     $(allLinksElements.get().reverse()).each(function(index) {
    //
    //       if (allLinksElements.length - index > iTheElementCount) {
    //         setTimeout(() => {
    //           $(this).removeClass('-in').addClass('-out');
    //
    //           setTimeout(() => {
    //             $(this).addClass('hidden');
    //           }, 200);
    //
    //         }, iTheDelay * index)
    //
    //       }
    //     });
    //
    //     setTimeout(() => {
    //       anime({
    //         targets: scrollElement,
    //         scrollTop: animateTo.offset().top,
    //         duration: 600,
    //         easing: 'easeInOutQuart'
    //       });
    //     }, 800);
    //
    //   }
    // });


  },
};



// WEBPACK FOOTER //
// ./scripts/components/link-listing.js